import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { citiesByState, SERVICE_LIST, CITIES } from "../data/locations";

export default function Standorte() {
  const grouped = citiesByState();
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: CITIES.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: `Energieberatung ${c.name}`,
      url: `https://www.energie-tarifberater.de/strom/${c.slug}`,
    })),
  };

  return (
    <>
      <Seo
        title="Standorte – Energieberatung deutschlandweit"
        description="Unabhängige Strom-, Gas- und Gewerbestromberatung in über 45 Städten und allen Bundesländern. Finden Sie Ihre Stadt und starten Sie den kostenlosen Tarifcheck."
        path="/standorte"
        schema={schema}
      />
      <PageHero
        eyebrow="Deutschlandweit"
        titleLines={["Energieberatung", 'an Ihrem <span class="font-serif italic text-blue-700">Standort.</span>']}
        subtitle="Wählen Sie Ihre Stadt – für unabhängige Strom-, Gas- und Gewerbestromberatung in ganz Deutschland."
        breadcrumb={[{ label: "Standorte" }]}
      />

      <section className="bg-background py-24 sm:py-32">
        <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
          {/* services quick links */}
          <Reveal>
            <div className="mb-16 flex flex-wrap gap-3">
              {SERVICE_LIST.map((s) => (
                <span key={s.slug} className="rounded-full bg-blue-50 text-blue-700 px-4 py-2 text-sm font-medium">
                  {s.label}
                </span>
              ))}
            </div>
          </Reveal>

          <div className="space-y-14">
            {grouped.map(([state, cities], gi) => (
              <Reveal key={state} delay={Math.min(gi * 0.04, 0.2)}>
                <div data-testid={`state-${state}`}>
                  <h2 className="text-2xl font-heading text-navy-900 mb-6 flex items-center gap-3">
                    <span className="h-1.5 w-8 rounded-full bg-blue-600" /> {state}
                  </h2>
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {cities.map((c) => (
                      <Link
                        key={c.slug}
                        to={`/standorte/${c.slug}`}
                        className="group flex items-center justify-between rounded-2xl border border-slate-200 bg-white px-6 py-5 hover:border-blue-400 hover:shadow-[0_20px_40px_-30px_rgba(29,78,216,0.4)] transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-0.5"
                        data-testid={`standort-${c.slug}`}
                      >
                        <span className="flex items-center gap-3">
                          <MapPin className="h-4 w-4 text-blue-600" />
                          <span className="font-heading text-navy-900">{c.name}</span>
                        </span>
                        <ArrowUpRight className="h-4 w-4 text-slate-400 group-hover:text-blue-700 transition-colors" />
                      </Link>
                    ))}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
